/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */

import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import ChevronIcon from 'Component/ChevronIcon';
import { BOTTOM } from 'Component/ChevronIcon/ChevronIcon.config';
import LockIcon from 'Component/LockIcon';

import './GdprCookieGroupItem.style.scss';

/** @namespace GdprCookie/Component/GdprCookieGroupItem/Component */
export class GdprCookieGroupItemComponent extends PureComponent {
    static propTypes = {
        isEssential: PropTypes.bool.isRequired,
        name: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        showPopup: PropTypes.func.isRequired,
        isChecked: PropTypes.bool.isRequired,
        handleToggleCheck: PropTypes.func.isRequired
    };

    renderToggle() {
        const {
            isEssential,
            isChecked,
            handleToggleCheck
        } = this.props;

        if (isEssential) {
            return (
                <div
                  block="GdprCookieGroupItem"
                  elem="Essential"
                >
                    <LockIcon />
                    <p>{ __('Always on') }</p>
                </div>
            );
        }

        return (
            // eslint-disable-next-line jsx-a11y/label-has-associated-control
            <label
              block="GdprCookieGroupItem"
              elem="Toggle"
            >
                <input
                  type="checkbox"
                  defaultChecked={ isEssential ? true : isChecked }
                  disabled={ isEssential }
                  onChange={ handleToggleCheck }
                />
                <span
                  block="GdprCookieGroupItem"
                  elem="Slider"
                  mods={ { isEssential } }
                />
            </label>
        );
    }

    renderHeadingAndToggle() {
        const {
            name
        } = this.props;

        return (
            <div
              block="GdprCookieGroupItem"
              elem="HeadingAndToggle"
            >
                <h2
                  block="GdprCookieGroupItem"
                  elem="Heading"
                >
                    { name }
                </h2>
                { this.renderToggle() }
            </div>
        );
    }

    renderDescription() {
        const { description } = this.props;

        return (
            <p
              block="GdprCookieGroupItem"
              elem="Description"
            >
                { description }
            </p>
        );
    }

    renderMoreInfo() {
        const { showPopup } = this.props;

        return (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
            <span
              block="GdprCookieGroupItem"
              elem="MoreInfo"
              onClick={ showPopup }
            >
                { __('See details') }
                <ChevronIcon direction={ BOTTOM } />
            </span>
        );
    }

    renderHero() {
        return (
            <div
              block="GdprCookieGroupItem"
              elem="Hero"
            >
                <h1>
                    { __('Cookie settings') }
                </h1>
                <p>
                    { /* eslint-disable-next-line max-len */ }
                    { __('The website won’t function properly without these cookies. We want to highlight that we value your privacy, and you will stay anonymous when browsing the webshop. When you place an order, your personal information is being handled with care.') }
                </p>
            </div>
        );
    }

    render() {
        return (
            <div
              block="GdprCookieGroupItem"
              elem="Wrapper"
            >
                <div
                  block="GdprCookieGroupItem"
                  elem="WrapperInner"
                >
                    { this.renderHeadingAndToggle() }
                    { this.renderDescription() }
                    { this.renderMoreInfo() }
                </div>
            </div>
        );
    }
}

export default GdprCookieGroupItemComponent;
